import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "helpers/jwt-token-access/customBaseQuery";

// Creating the API slice for pageSettings
export const pageSettingsSlice = createApi({
  reducerPath: "pageSettings",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    // Feature Flag Endpoints
    getFeatureFlags: builder.query({
      query: () => "/organization/api/v1/app_featureflag/",
    }),
    getFeatureFlagById: builder.query({
      query: (id) => `/organization/api/v1/app_featureflag/${id}/`,
    }),
    updateFeatureFlagById: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/organization/api/v1/app_featureflag/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),

    // App Settings Endpoints
    getAppSettings: builder.query({
      query: () => "/organization/api/v1/app_settings/",
    }),
    getAppSettingById: builder.query({
      query: (id) => `/organization/api/v1/app_settings/${id}/`,
    }),
    updateAppSettingById: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/organization/api/v1/app_settings/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),

    //Health Declaration End points

    // General permit
    getGeneralWorkPermitHealthDeclaration: builder.query({
      query: () => "/safety_app/api/v1/general_work_permit_health_declaration/",
    }),
    getGeneralWorkPermitHealthDeclarationById: builder.query({
      query: (id) =>
        `/safety_app/api/v1/general_work_permit_health_declaration/${id}/`,
    }),
    createGeneralWorkPermitHealthDeclaration: builder.mutation({
      query: (newRole) => ({
        url: "/safety_app/api/v1/general_work_permit_health_declaration/",
        method: "POST",
        body: newRole,
      }),
    }),
    updateGeneralWorkPermitHealthDeclarationId: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/safety_app/api/v1/general_work_permit_health_declaration/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),
    // Confined space
    getConfinedSpaceHealthDeclaration: builder.query({
      query: () =>
        "/safety_app/api/v1/confined_space_permit_health_declaration/",
    }),
    getConfinedSpaceHealthDeclarationById: builder.query({
      query: (id) =>
        `/safety_app/api/v1/confined_space_permit_health_declaration/${id}/`,
    }),
    createConfinedSpaceHealthDeclaration: builder.mutation({
      query: (newRole) => ({
        url: "/safety_app/api/v1/confined_space_permit_health_declaration/",
        method: "POST",
        body: newRole,
      }),
    }),
    updateConfinedSpaceHealthDeclarationId: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/safety_app/api/v1/confined_space_permit_health_declaration/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),
    //HotWork Permit
    getHotWorkPermitHealthDeclaration: builder.query({
      query: () => "/safety_app/api/v1/hot_work_permit_health_declaration/",
    }),
    getHotWorkPermitHealthDeclarationById: builder.query({
      query: (id) =>
        `/safety_app/api/v1/hot_work_permit_health_declaration/${id}/`,
    }),
    createHotWorkPermitHealthDeclaration: builder.mutation({
      query: (newRole) => ({
        url: "/safety_app/api/v1/hot_work_permit_health_declaration/",
        method: "POST",
        body: newRole,
      }),
    }),
    updateHotWorkPermitHealthDeclarationId: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/safety_app/api/v1/hot_work_permit_health_declaration/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),
    //Lifting Permit
    getLiftingPermitHealthDeclaration: builder.query({
      query: () => "/safety_app/api/v1/lifting_permit_health_declaration/",
    }),
    getLiftingPermitHealthDeclarationById: builder.query({
      query: (id) =>
        `/safety_app/api/v1/lifting_permit_health_declaration/${id}/`,
    }),
    createLiftingPermitHealthDeclaration: builder.mutation({
      query: (newRole) => ({
        url: "/safety_app/api/v1/lifting_permit_health_declaration/",
        method: "POST",
        body: newRole,
      }),
    }),
    updateLiftingPermitHealthDeclarationId: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/safety_app/api/v1/lifting_permit_health_declaration/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),
    //Piling Permit
    getPilingPermitHealthDeclaration: builder.query({
      query: () => "/safety_app/api/v1/piling_permit_health_declaration/",
    }),
    getPilingPermitHealthDeclarationById: builder.query({
      query: (id) =>
        `/safety_app/api/v1/piling_permit_health_declaration/${id}/`,
    }),
    createPilingPermitHealthDeclaration: builder.mutation({
      query: (newRole) => ({
        url: "/safety_app/api/v1/piling_permit_health_declaration/",
        method: "POST",
        body: newRole,
      }),
    }),
    updatePilingPermitHealthDeclarationId: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/safety_app/api/v1/piling_permit_health_declaration/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),
    //PipeJacking Permit
    getPipeJackingPermitHealthDeclaration: builder.query({
      query: () => "/safety_app/api/v1/pipe_jacking_permit_health_declaration/",
    }),
    getPipejackingPermitHealthDeclarationById: builder.query({
      query: (id) =>
        `/safety_app/api/v1/pipe_jacking_permit_health_declaration/${id}/`,
    }),
    createPipeJackingPermitHealthDeclaration: builder.mutation({
      query: (newRole) => ({
        url: "/safety_app/api/v1/pipe_jacking_permit_health_declaration/",
        method: "POST",
        body: newRole,
      }),
    }),
    updatePipeJackingPermitHealthDeclarationId: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/safety_app/api/v1/pipe_jacking_permit_health_declaration/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),
    //Toolbox
    getToolBoxHealthDeclaration: builder.query({
      query: () => "/safety_app/api/v1/tool_box_health_declaration/",
    }),
    getToolBoxHealthDeclarationById: builder.query({
      query: (id) => `/safety_app/api/v1/tool_box_health_declaration/${id}/`,
    }),
    createToolBoxHealthDeclaration: builder.mutation({
      query: (newRole) => ({
        url: "/safety_app/api/v1/tool_box_health_declaration/",
        method: "POST",
        body: newRole,
      }),
    }),
    updateToolBoxHealthDeclarationId: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/safety_app/api/v1/tool_box_health_declaration/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),
    //WorkAtHeightPermit
    getWorkAtHeightPermitHealthDeclaration: builder.query({
      query: () =>
        "/safety_app/api/v1/work_at_height_permit_health_declaration/",
    }),
    getWorkAtHeightPermitHealthDeclarationById: builder.query({
      query: (id) =>
        `/safety_app/api/v1/work_at_height_permit_health_declaration/${id}/`,
    }),
    createWorkAtHeightPermitHealthDeclaration: builder.mutation({
      query: (newRole) => ({
        url: "/safety_app/api/v1/work_at_height_permit_health_declaration/",
        method: "POST",
        body: newRole,
      }),
    }),
    updateWorkAtHeightPermitHealthDeclarationId: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/safety_app/api/v1/work_at_height_permit_health_declaration/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),
    //Excavation Permit
    getExcavationPermitHealthDeclaration: builder.query({
      query: () => "/safety_app/api/v1/excavation_permit_health_declaration/",
    }),
    getExcavationPermitHealthDeclarationById: builder.query({
      query: (id) =>
        `/safety_app/api/v1/excavation_permit_health_declaration/${id}/`,
    }),
    createExcavationPermitHealthDeclaration: builder.mutation({
      query: (newRole) => ({
        url: "/safety_app/api/v1/excavation_permit_health_declaration/",
        method: "POST",
        body: newRole,
      }),
    }),
    updateExcavationPermitHealthDeclarationId: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/safety_app/api/v1/excavation_permit_health_declaration/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),

    //EquipmentUsed
    getEquipmentUsed: builder.query({
      query: () => "/equipment_used/api/v1/equipment_used/",
    }),
    getEquipmentUsedById: builder.query({
      query: (id) => `/equipment_used/api/v1/equipment_used/${id}/`,
    }),
    createEquipmentUsed: builder.mutation({
      query: (newRole) => ({
        url: "/equipment_used/api/v1/equipment_used/",
        method: "POST",
        body: newRole,
      }),
    }),
    updateEquipmentUsedId: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/equipment_used/api/v1/equipment_used/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),
    getEquipmentUsedType: builder.query({
      query: () => "/equipment_used/api/v1/equipment_used_type/",
    }),
    getEquipmentUsedTypeById: builder.query({
      query: (id) => `/equipment_used/api/v1/equipment_used_type/${id}/`,
    }),
    createEquipmentUsedType: builder.mutation({
      query: (newRole) => ({
        url: "/equipment_used/api/v1/equipment_used_type/",
        method: "POST",
        body: newRole,
      }),
    }),
    updateEquipmentUsedTypeId: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/equipment_used/api/v1/equipment_used_type/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),

    //EquipmentUsedQuestionnaire
    getEquipmentUsedQuestionnaireKey: builder.query({
      query: () => "/equipment_used/api/v1/equipment_used_questionnaire_key/",
    }),
    getEquipmentUsedQuestionnaireKeyById: builder.query({
      query: (id) =>
        `/equipment_used/api/v1/equipment_used_questionnaire_key/?equipment_used_list=${id}`,
    }),
    getEquipmentUsedQuestionnaireKeyTypeById: builder.query({
      query: (id) =>
        `/equipment_used/api/v1/equipment_used_questionnaire_key/?equipment_used_type_list=${id}`,
    }),
    createEquipmentUsedQuestionnaireKey: builder.mutation({
      query: (newRole) => ({
        url: "/equipment_used/api/v1/equipment_used_questionnaire_key/",
        method: "POST",
        body: newRole,
      }),
    }),
    updateEquipmentUsedQuestionnaireKeyById: builder.mutation({
      query: ({ id, updateData }) => ({
        url: `/equipment_used/api/v1/equipment_used_questionnaire_key/${id}/`,
        method: "PATCH",
        body: updateData,
      }),
    }),

    //Company View

    getCompanyLogoView: builder.query({
      query: () => "/organization/api/v1/company_view/",
    }),
    createCompanyLogoView: builder.mutation({
      query: (newRole) => ({
        url: "/organization/api/v1/company_view/",
        method: "POST",
        body: newRole,
      }),
    }),
  }),
});

// Exporting hooks for the queries and mutations
export const {
  useGetFeatureFlagsQuery,
  useGetFeatureFlagByIdQuery,
  useUpdateFeatureFlagByIdMutation,
  useGetAppSettingsQuery,
  useGetAppSettingByIdQuery,
  useUpdateAppSettingByIdMutation,

  // All Permit Health Declaration hooks for the queries and mutations
  useCreateGeneralWorkPermitHealthDeclarationMutation,
  useUpdateGeneralWorkPermitHealthDeclarationIdMutation,
  useGetGeneralWorkPermitHealthDeclarationByIdQuery,
  useGetGeneralWorkPermitHealthDeclarationQuery,

  useCreateConfinedSpaceHealthDeclarationMutation,
  useUpdateConfinedSpaceHealthDeclarationIdMutation,
  useGetConfinedSpaceHealthDeclarationByIdQuery,
  useGetConfinedSpaceHealthDeclarationQuery,

  useCreateHotWorkPermitHealthDeclarationMutation,
  useUpdateHotWorkPermitHealthDeclarationIdMutation,
  useGetHotWorkPermitHealthDeclarationByIdQuery,
  useGetHotWorkPermitHealthDeclarationQuery,

  useCreateLiftingPermitHealthDeclarationMutation,
  useUpdateLiftingPermitHealthDeclarationIdMutation,
  useGetLiftingPermitHealthDeclarationByIdQuery,
  useGetLiftingPermitHealthDeclarationQuery,

  useCreatePilingPermitHealthDeclarationMutation,
  useUpdatePilingPermitHealthDeclarationIdMutation,
  useGetPilingPermitHealthDeclarationByIdQuery,
  useGetPilingPermitHealthDeclarationQuery,

  useCreatePipeJackingPermitHealthDeclarationMutation,
  useUpdatePipeJackingPermitHealthDeclarationIdMutation,
  useGetPipeJackingPermitHealthDeclarationQuery,
  useGetPipejackingPermitHealthDeclarationByIdQuery,

  useCreateToolBoxHealthDeclarationMutation,
  useUpdateToolBoxHealthDeclarationIdMutation,
  useGetToolBoxHealthDeclarationByIdQuery,
  useGetToolBoxHealthDeclarationQuery,

  useCreateWorkAtHeightPermitHealthDeclarationMutation,
  useUpdateWorkAtHeightPermitHealthDeclarationIdMutation,
  useGetWorkAtHeightPermitHealthDeclarationByIdQuery,
  useGetWorkAtHeightPermitHealthDeclarationQuery,

  useCreateExcavationPermitHealthDeclarationMutation,
  useUpdateExcavationPermitHealthDeclarationIdMutation,
  useGetExcavationPermitHealthDeclarationByIdQuery,
  useGetExcavationPermitHealthDeclarationQuery,

  //EquipmentUsed
  useCreateEquipmentUsedMutation,
  useUpdateEquipmentUsedIdMutation,
  useCreateEquipmentUsedTypeMutation,
  useUpdateEquipmentUsedTypeIdMutation,
  useGetEquipmentUsedByIdQuery,
  useGetEquipmentUsedQuery,
  useGetEquipmentUsedTypeByIdQuery,
  useGetEquipmentUsedTypeQuery,

  //EquipmentUsedQuestionnaire
  useCreateEquipmentUsedQuestionnaireKeyMutation,
  useUpdateEquipmentUsedQuestionnaireKeyByIdMutation,
  useGetEquipmentUsedQuestionnaireKeyByIdQuery,
  useGetEquipmentUsedQuestionnaireKeyTypeByIdQuery,
  useGetEquipmentUsedQuestionnaireKeyQuery,

  //Company View
  useGetCompanyLogoViewQuery,
} = pageSettingsSlice;
